// extracted by mini-css-extract-plugin
export var copyableField = "_px-4";
export var customerBadge = "_px-0";
export var customerInfoTitle = "_px-2";
export var details = "_px-1";
export var dropdownContainer = "_px-5";
export var dropdownImage = "_px-6";
export var editAssigneeForm = "_px-a";
export var editButton = "_px-3";
export var email = "_px-7";
export var hidden = "_px-d";
export var input = "_px-8";
export var saveButton = "_px-b";
export var shopifyIcon = "_px-c";
export var suggestionBadge = "_px-e";
export var suggestionText = "_px-f";
export var username = "_px-9";